export default "__VITE_ASSET__DZbhDcrW__"